export default function reverseDictionary(dict) {
  return Object.entries(dict).reduce((acc, [key, value]) => {
    acc[value] = key;
    return acc;
  }, {});
}
